/**
 * Badge can be rendered in these types
 */
export var BadgeType;

(function (BadgeType) {
  BadgeType["Error"] = "ERROR";
  BadgeType["Warning"] = "WARNING";
})(BadgeType || (BadgeType = {}));